<div *ngIf="loading" class="loading-text">
  <p>{{ 'PleaseWaitDataLoading' | translate }}</p>
</div>
  
<div *ngIf="!loading">
<app-sub-header [pageTitle]="'Messages' | translate"></app-sub-header>

<div class="padded-container">
  <div *ngIf="!loading">
  <dx-accordion [collapsible]="true" [multiple]="true" [selectedItems]="[]">
    <dxi-item [title]="('UnreadMessages' | translate) + ' (' + unreadMessages.length + ')'" [expanded]="false">
    <ng-container *ngIf="messagesResponse && unreadMessages.length">
      <ng-container *ngFor="let messageItem of unreadMessages">
      <dx-accordion [collapsible]="true" [multiple]="true" [selectedItems]="[]">
        <dxi-item [title]="truncateMessage(messageItem.messageText) + ' ' + (messageItem.timeSent | date: 'dd.MM.yyyy HH:mm')" [expanded]="false">
        <div>
          <div class="message-text">{{ messageItem.messageText }}</div>
          <ng-container *ngFor="let response of messageItem.responses">
          <dx-button class="full-width-button" text="{{ response.responseText }}" type="default" (onClick)="postMessageAnswer(messageItem.messageId, response.responseId)">
          </dx-button>
          </ng-container>
        </div>
        </dxi-item>
      </dx-accordion>
      </ng-container>
    </ng-container>
    </dxi-item>
  </dx-accordion>

  <dx-accordion [collapsible]="true" [multiple]="true" [selectedItems]="[]">
    <dxi-item [title]="('ReadMessages' | translate) + ' (' + readMessages.length + ')'" [expanded]="false">
    <ng-container *ngIf="messagesResponse && readMessages.length">
      <ng-container *ngFor="let messageItem of readMessages">
      <dx-accordion [collapsible]="true" [multiple]="true" [selectedItems]="[]">
        <dxi-item [title]="truncateMessage(messageItem.messageText) + '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' + (messageItem.timeSent | date: 'dd.MM.yyyy HH:mm')" [expanded]="false">
        <div>
          <div class="message-text">{{ messageItem.messageText }}</div>
          <br>
          <div>{{ 'Answered' | translate }}: {{ messageItem.responsedText }}</div>
        </div>
        </dxi-item>
      </dx-accordion>
      </ng-container>
    </ng-container>
    </dxi-item>
  </dx-accordion>
  </div>
</div>